function convertMinutesToSeconds(minutes) {
  return minutes * 60;
}

const ONE_MINUTE_IN_SECONDS = convertMinutesToSeconds(1);
const FIFTEEN_MINUTES_IN_SECONDS = convertMinutesToSeconds(15);

/**
 * Extracts the logic concerning token expiry to optimized function. Standard memoization is not a
 * good fit for optimizing this logic (and would be a memory leak) as the inputs will almost
 * always be different. This optimized memoization only caches a single result.
 */
const evaluateTokenExpiry = (() => {
  // Setup the cache. This will hold previously run evaluations.
  const cache = {};

  const evaluate = (currentTimeInSeconds, tokenExpiryInSeconds) => {
    const key = `${currentTimeInSeconds}:${tokenExpiryInSeconds}`;
    // This currentTime has already been processed. Return previous results.
    if (cache[key]) {
      return cache[key];
    }

    // Time will not go backwards. After this second passes there is no reason to maintain old
    // results. If the currentTimeInSeconds is not in the cache, nothing should be.
    Object.keys(cache).forEach((k) => {
      delete cache[k];
    });

    // Evaluates to true if the token is present and current time is within 1 minute of,
    // or after expiry.
    const expired = !!(
      tokenExpiryInSeconds &&
      (currentTimeInSeconds + ONE_MINUTE_IN_SECONDS) > tokenExpiryInSeconds
    );

    // Evaluates to true only if expired is false and the token is within 15 minutes of expiry.
    const almostExpired = !expired && !!(
      tokenExpiryInSeconds &&
      (currentTimeInSeconds + FIFTEEN_MINUTES_IN_SECONDS) > tokenExpiryInSeconds &&
      currentTimeInSeconds < tokenExpiryInSeconds
    );

    const result = { almostExpired, expired };

    // Save this result so we can return without re-evaluating these inputs in the future.
    cache[key] = result;

    return result;
  };

  // Return the evaluation function.
  return evaluate;
})();

export default evaluateTokenExpiry;



// WEBPACK FOOTER //
// ./features/authentication/utils/evaluateTokenExpiry.js